import React from 'react'
import { FormattedDate } from 'react-intl'
import { RatingStars } from 'components/Reviews/components/RatingStars'
import { ReviewListWrapper, ReviewItem } from './components/Styled'

interface Prop {
  reviewList: any
  reviewsCount?: number
}

export const ReviewList: React.FC<Prop> = ({ reviewList, reviewsCount }) => {
  return (
    <ReviewListWrapper>

      {reviewList?.map((review: any, i: number) => {
        const {
          nickname,
          created_at: createdAt,
          detail,
          title,
          rating_votes: ratingVotes
        } = review

        const rating = ratingVotes[0]?.value ?? ''
        const dateNumber = new Date(createdAt)

        return (
          <ReviewItem key={i}>
            <div className='review__overview'>
              <RatingStars
                ratingCount={rating}
              />
              <h4>{title}</h4>
            </div>
            <div className='review__content'>
              <p className='review__name'>
                <strong>{nickname}</strong>
              </p>
              <p className='review__date'>
                <FormattedDate
                  value={dateNumber}
                  year='numeric'
                  month='long'
                  day='2-digit'
                />
              </p>
              <p className='review__detail'>{detail}</p>
            </div>
          </ReviewItem>
        )
      })}
    </ReviewListWrapper>
  )
}
